import { Input } from 'antd';
import React, { FC } from 'react';
import { useDirection } from '~/hooks';

type Props = {
  [x: string]: any;
};

const PhoneInput: FC<Props> = (props: Props) => {
  const { style } = props;
  const [direction] = useDirection();
  return (
    <Input
      {...props}
      style={{
        direction: 'ltr',
        textAlign: direction === 'rtl' ? 'right' : undefined,
        ...(style || {}),
      }}
    />
  );
};

export default PhoneInput;
